"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var EscalationBanner = function EscalationBanner(_ref) {
  var component = _ref.component;

  if (component.type === 'zendesk_ticket_creation') {
    return (0, _preact.h)("div", {
      className: "forethought-agent__escalation"
    }, (0, _preact.h)("div", {
      className: "forethought-agent__escalation-title"
    }, "Ticket created"), (0, _preact.h)("div", {
      className: "forethought-agent__escalation-body"
    }, "Ticket ", (0, _preact.h)("strong", null, "#", component.ticket_id), " has been opened. A support agent will follow up shortly."));
  }

  var isSalesforce = component.type === 'salesforce_handoff';
  return (0, _preact.h)("div", {
    className: "forethought-agent__escalation"
  }, (0, _preact.h)("div", {
    className: "forethought-agent__escalation-title"
  }, "Connecting you to a ", isSalesforce ? 'Salesforce' : 'support', " agent"), (0, _preact.h)("div", {
    className: "forethought-agent__escalation-body"
  }, component.visitor_question ? "We're escalating your question: \"".concat(component.visitor_question, "\"") : 'A support agent will be with you shortly.'));
};

var _default = EscalationBanner;
exports.default = _default;